export default __webpack_public_path__ + "static/media/bubble1.0ffd447f.png";